import React from "react";
import HiddenNav from "./HiddenNav";
import cn from "classnames";
import { Grid, IconButton, Tooltip } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import { updateSection } from "../../Tools/Tools";
import SmetaBreadcrumbs from "./Breadcumbs";
import { useAtomValue } from "jotai";
import { currentTheme } from "../../../../atoms";

export default function SubHeader(props: any) {
  const theme = useAtomValue(currentTheme);
  // const currentUserInfo: any = get_cookie("LastLogin").split(",");

  return (
    <Grid
      className={cn("headerStimate", { light: theme === "light" })}
      item
      style={{
        height: "34px",
        overflow: "hidden",
        width: "100%",
        position: "inherit",
        top: "48px",
        flex: "0 1 auto",
      }}
    >
      {/* boxShadow: "0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)" */}
      <div
        id="miniMenu"
        style={{
          display: "-webkit-box",
          alignItems: "center",
          width: "inherit",
          height: "inherit",
        }}
      >
        {/* <Grid container direction="row" justifyContent="flex-start" alignItems="center" > */}
        <HiddenNav drawerOpen={props.drawerOpen} />
        {/* </Grid> */}
        <div
          className={cn("fontColorStimate", { light: theme === "light" })}
          id="NameSection"
          style={{
            paddingTop: "6px",
            fontFamily: "Roboto,Helvetica,Arial, sans-serif",
            fontWeight: "500",
            fontSize: "1rem",
            marginLeft: `${props.drawerOpen ? 10 : 0}px`,
          }}
        >
          {/* {getName()} */}

          <SmetaBreadcrumbs />
        </div>
        <div id="refreshbuttonforall">
          <Tooltip title="Обновить секцию" placement="right">
            <IconButton
              style={{ padding: "8px" }}
              onClick={() => {
                updateSection();
              }}
            >
              <RefreshIcon className={cn("iconButtonStimate", { light: theme === "light" })} fontSize="small" />
            </IconButton>
          </Tooltip>
        </div>
      </div>
    </Grid>
  );
}
